import React, { useEffect, useState } from 'react';

import { HStack, Spinner, Text } from '@betterment/samba-react';

const LOADING_MESSAGES = [
  'Analyzing your current accounts...',
  'Looking at your income, assets, tax status...',
  'Determining your next best account...',
];

export const LoadingReasoningAnimation: React.FC = () => {
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentMessageIndex(prevIndex => {
        if (prevIndex < LOADING_MESSAGES.length - 1) {
          return prevIndex + 1;
        }
        return prevIndex;
      });
    }, 2000);

    return () => clearInterval(timer);
  }, []);

  return (
    <HStack css={{ gap: 'space.100', alignItems: 'center', justifyContent: 'space-between' }}>
      <Text variant="text50" color="text">
        {LOADING_MESSAGES[currentMessageIndex]}
      </Text>
      <Spinner size="sm" css={{ color: 'text.weak' }} />
    </HStack>
  );
};
